import { httpClient } from "./httpClient";

const getAllBetweenSiteCars = () => {
  return httpClient.get("between_site_cars");
};

const getBetweenSiteCarById = (Id) => {
  return httpClient.get("between_site_car/" + Id);
};

const getBetweenSiteCarByFilter = (filter) => {
  return httpClient.post(`between_site_car_filter`, filter);
};
const getBetweenSiteCarByIdUserIsNotFinish = (IdUser) => {
  return httpClient.get("between_site_car_is_notFinish/" + IdUser);
};

// const getUpdateTargetStatusById = (id) => {
//   return httpClient.get("update_target_status_call_car/" + id);
// };

const updateTargetStatusById = (data) => {
  return httpClient.post(`update_target_status_call_car`, data);
};

const getBetweenSiteBookingDetailById = (Id) => {
  return httpClient.get("between_site_car_detail/" + Id);
};

const getNearestTimeAndDistance = (getting, to, idUser) => {
  return httpClient.get(`map_distance_time/${getting}/${to}/${idUser}`);
};

const callCar = (data) => {
  return httpClient.post("callCar", data);
};
const setFinishCallCar = (data) => {
  return httpClient.post("set_finish_call_car", data);
};
const CancelCallCar = (data) => {
  return httpClient.post("cancel_between_site_car", data);
};
const getSite = () => {
  return httpClient.get("getsite");
};
const postNewBetweenSiteCar = (newdata) => {
  return httpClient.post("post_new_between_site_car", newdata);
};
const updateDriverRoute = (idDriverRouteDay) => {
  return httpClient.post("update_driver_route", idDriverRouteDay);
};
const postOptimizedRouteBetweenSiteCar = () => {
  return httpClient.post("otimized_route_between_site_car");
};
const postEditBetweenSiteCar = (newData, id) => {
  if (newData) {
    return httpClient.post("edit_between_site_car" + `/${id}`, newData);
  }
};
const deleteBetweenSiteCar = (data) => {
  return httpClient.post("delete_between_site_car", data);
};

const getBetweenSiteByAdminFilter = (data) => {
  return httpClient.post("get_between_site_by_admin_filter", data);
};

export default {
  getAllBetweenSiteCars,
  getBetweenSiteCarByIdUserIsNotFinish,
  getBetweenSiteCarById,
  getBetweenSiteCarByFilter,
  callCar,
  setFinishCallCar,
  updateTargetStatusById,
  getBetweenSiteBookingDetailById,
  getNearestTimeAndDistance,
  CancelCallCar,
  getSite,
  postNewBetweenSiteCar,
  updateDriverRoute,
  postOptimizedRouteBetweenSiteCar,
  postEditBetweenSiteCar,
  deleteBetweenSiteCar,
  getBetweenSiteByAdminFilter,
};
